export enum NoticeTypes {
	Unsure = "Unsure",
	Yes = "Yes",
	No = "No",
}
